import { render, staticRenderFns } from "./RAW.vue?vue&type=template&id=2a54819a&scoped=true&"
import script from "./RAW.vue?vue&type=script&lang=ts&"
export * from "./RAW.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a54819a",
  null
  
)

export default component.exports